import React, { useState } from "react";
import axios from "axios";
import { message } from "antd";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import SignInBanner from "../images/banners/same.jpg"; // ✅ Import Background Image

function SignInPage() {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({});
  const navigate = useNavigate(); // ✅ Redirect after login

  // ✅ Handle Input Change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // ✅ Validate Form
  const validate = () => {
    let tempErrors = {};
    tempErrors.email = /^\S+@\S+\.\S+$/.test(formData.email) ? "" : "Invalid email address.";
    tempErrors.password = formData.password.length >= 6 ? "" : "Password must be at least 6 characters.";
    setErrors(tempErrors);
    return Object.values(tempErrors).every((x) => x === "");
  };

  // ✅ Handle Form Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      const response = await axios.post("http://93.127.203.113:5005/passengers/login", formData);
      message.success("Sign in successful!");

      // ✅ Store Token in LocalStorage
      localStorage.setItem("accessToken", response.data.accessToken);
      localStorage.setItem("passengerData", JSON.stringify(response.data.passengerData));

      // ✅ Redirect to Home
      navigate("/");
    } catch (error) {
      message.error(error.response?.data?.msg || "Invalid credentials. Please try again.");
    }
  };

  return (
    <>
      <section className="signin-page">
        <HeroPages name="Sign In" />
        <div className="container">
          <div className="signin-main">
            {/* Left Section: Image */}
            <div className="signin-main__img-wrapper">
              <img className="signin-main__img" src={SignInBanner} alt="signin-section" />
            </div>

            {/* Right Section: Form */}
            <div className="signin-main__text">
              <h2 className="signin-main__title">Welcome Back!</h2>
              <h3 className="signin-main__subtitle">Sign in to continue</h3>

              <form onSubmit={handleSubmit} className="signin-form">
                <label>Email Address <b>*</b></label>
                <input
                  type="email"
                  name="email"
                  placeholder="youremail@example.com"
                  value={formData.email}
                  onChange={handleChange}
                  className={errors.email ? "input-error" : ""}
                />
                {errors.email && <span className="error-msg">{errors.email}</span>}

                <label>Password <b>*</b></label>
                <input
                  type="password"
                  name="password"
                  placeholder="Enter your password"
                  value={formData.password}
                  onChange={handleChange}
                  className={errors.password ? "input-error" : ""}
                />
                {errors.password && <span className="error-msg">{errors.password}</span>}

                <button type="submit">
                  <i className="fa-solid fa-sign-in-alt"></i>&nbsp; Sign In
                </button>
              </form>

              <p className="register-link">
                Don't have an account? <Link to="/register">Register Here</Link>
              </p>
            </div>
          </div>
        </div>

        <Footer />
      </section>
      <style jsx>{`
        .signin-page {
          width: 100%;
          padding: 80px 20px;
          background-color: #f8f9fa;
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .signin-main {
          display: flex;
          gap: 40px;
          align-items: center;
          justify-content: center;
        }

        .signin-main__img-wrapper {
          width: 45%;
          border-radius: 10px;
          overflow: hidden;
        }

        .signin-main__img {
          width: 100%;
          height: auto;
          border-radius: 10px;
        }

        .signin-main__text {
          width: 50%;
        }

        .signin-main__title {
          font-size: 3rem;
          color: #333;
          margin-bottom: 10px;
        }

        .signin-main__subtitle {
          font-size: 1.8rem;
          color: #0c8c49;
          text-transform: uppercase;
          letter-spacing: 2px;
          margin-bottom: 15px;
        }

        .signin-form {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }

        .signin-form label {
          font-size: 1.6rem;
          font-weight: 500;
        }

        .signin-form input {
          padding: 12px;
          font-size: 1.4rem;
          border: 1px solid #ddd;
          border-radius: 5px;
          transition: border 0.3s ease-in-out;
        }

        .signin-form input:focus {
          border-color: #0c8c49;
        }

        .signin-form button {
          background: #0c8c49;
          color: white;
          padding: 12px;
          font-size: 1.6rem;
          border: none;
          border-radius: 5px;
          cursor: pointer;
          transition: background 0.3s ease-in-out;
        }

        .signin-form button:hover {
          background: #09733a;
        }

        .register-link {
          margin-top: 15px;
          font-size: 1.4rem;
        }

        .register-link a {
          color: #0c8c49;
          font-weight: bold;
        }

        .error-msg {
          color: red;
          font-size: 1.2rem;
        }

        .input-error {
          border-color: red;
        }

        @media (max-width: 1024px) {
          .signin-main {
            flex-direction: column;
            text-align: center;
          }

          .signin-main__img-wrapper {
            width: 80%;
          }

          .signin-main__text {
            width: 80%;
          }
        }

        @media (max-width: 768px) {
          .signin-main__title {
            font-size: 2.5rem;
          }
        }
      `}</style>
    </>
  );
}

export default SignInPage;
